import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 12 12",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8.446 1.605a.82.82 0 010 1.14L5.291 6l3.155 3.254a.82.82 0 11-1.175 1.141L3 6l4.27-4.395a.82.82 0 011.176 0z"
	})]
});
const ForwardRef = forwardRef(SvgArrowLeft);
export default ForwardRef;
